export const alertSelector = state => state.alerts.alert
export const notificationsSelector = state => state.alerts.notifications
